export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "productName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VR Chemistry Lab"])}
      },
      "en": {
        "productName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vic’s Science Studio"])}
      }
    }
  })
}
